import { useState } from "react";
import { Card } from "reactstrap";
import { LuPencil } from "react-icons/lu";
import { EditBillingAddressModal } from "../modals/EditAddressModal";

const BillingDetailsCard = ({ billingData, setBillingData }) => {
  const [editBillingModal, setEditBillingModal] = useState(false);
  const toggleBillingModal = () => setEditBillingModal(!editBillingModal);

  const handleBillingEdit = () => toggleBillingModal();
  const handleBillingSave = (updatedData) => {
    setBillingData(updatedData);
    toggleBillingModal();
  };

  return (
    <>
      <EditBillingAddressModal
        modal={editBillingModal}
        toggle={toggleBillingModal}
        billingData={billingData}
        setBillingData={setBillingData}
        onSave={handleBillingSave}
      />

      <Card
        className="border-0 shadow-sm rounded-12 p-4 bg-white billing-card h-100"
        style={{ transition: "all 0.3s ease", borderRadius: "16px", border: "1px solid #f1f5f9" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
          <h5 className="fw-bold text-dark mb-0 fs-18">Billing Information</h5>
          <div
            className="p-2 rounded-8 bg-primary-soft pointer transition-all"
            onClick={handleBillingEdit}
            style={{ width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <LuPencil
              className="text-primary"
              size={18}
            />
          </div>
        </div>

        <div className="billing-details">
          {[
            { label: "Company", value: billingData?.company },
            {
              label: "Name",
              value: `${billingData?.first_name ?? ""} ${billingData?.last_name ?? ""
                }`.trim(),
            },
            { label: "EIN", value: billingData?.EIN || billingData?.ein },
            { label: "Address Line 1", value: billingData?.address_1 },
            { label: "Address Line 2", value: billingData?.address_2 },
            {
              label: "Location",
              value: billingData
                ? `${billingData?.city ?? ""}, ${billingData?.state ?? ""} ${billingData?.postcode ?? ""
                  }`.trim()
                : "",
            },
            { label: "Phone", value: billingData?.phone },
            { label: "Email", value: billingData?.email },
          ]?.map((item, idx, arr) => (
            <div
              key={idx}
              className="d-flex justify-content-between align-items-start py-3 border-bottom-subtle"
              style={{ borderBottom: idx === arr.length - 1 ? "none" : "1px solid #f1f5f9" }}
            >
              <span className="fs-14 fw-600 text-muted">{item.label}</span>
              <span className="fs-14 fw-500 text-dark text-end ps-3">
                {item?.value && String(item?.value).trim() !== "" ? item.value : "—"}
              </span>
            </div>
          ))}
        </div>
      </Card>
    </>
  );
};

export default BillingDetailsCard;
